import { X } from "lucide-react";
import { MicroAppAccessTab } from "./MicroAppAccessTab";

/** Modal wrapper around the membership access tab. */
export function MicroAppAccessModal({
  appUuid,
  appName,
  isOpen,
  onClose,
}: Readonly<{ appUuid: string; appName: string; isOpen: boolean; onClose: () => void }>) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-surface-overlay flex items-center justify-center z-50 p-4">
      <div className="bg-surface-primary border border-border-primary rounded-xl shadow-xl max-w-lg w-full max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-border-primary">
          <div className="min-w-0">
            <h2 className="text-lg font-semibold text-content-primary truncate">Share “{appName}”</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 hover:bg-interactive-active rounded-lg transition"
            aria-label="Close"
          >
            <X className="h-5 w-5 text-content-tertiary" />
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-visible p-4">
          <MicroAppAccessTab appUuid={appUuid} />
        </div>
      </div>
    </div>
  );
}
